"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clone = void 0;
// Use syntax "import module = require('module') because type def is "export = deepmerge"
// See https://www.typescriptlang.org/docs/handbook/modules.html#export--and-import--require
const clone = require("clone-deep");
exports.clone = clone;
//# sourceMappingURL=clone.js.map